<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="600px"
    :persistent="true"
  >
    <v-card>
      <v-card-title class="subheading">
        {{ loading ? '正在删除…': '确认删除？' }}
      </v-card-title>

      <v-divider></v-divider>

      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <p class="subheading" v-html="message"></p>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn flat color="primary" @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" :disabled="loading" @click.native="onDelete">确认</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: ['value', 'message', 'uri', 'dbid'],

    data() {
      return {
        loading: false
      }
    },

    computed: {
      visible: {
        // getter
        get: function () {
          return this.value;
        },
        // setter
        set: function (nv) {
          this.$emit('input', nv);
        }
      }
    },

    methods: {
      /**
       * **************************************************************
       * 异步数据请求
       */
      onDelete() {
        const vm = this;
        this.loading = true;
        this.axios.delete(`${this.uri}/${this.dbid}`)
          .then(rsp => {
            // 填充对话框
            vm.$emit('ok', rsp.data);
            vm.loading = false;
            this.visible = false;
          });
      }

    }
  }
</script>
<style scoped>
  div.card div.card__text {
    display: flex;
    font-size: 14px;
    margin: 4px auto;
    padding: 8px 15px;
    position: relative;
  }

  div.card div.card__text > div {
    -ms-flex-item-align: center;
    align-self: center;
    -webkit-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
    margin-left: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/Delete.vue